import React from 'react'
import PropTypes from 'prop-types'

const ErrorBlock = ({headerText, descriptionText}) => (
  <>
    <div className="text-red-dark text-sm bg-grey-lighter p-4 border-red-dark border-l">
      <div className="font-bold">
        {headerText}
      </div>
      <div>
        {descriptionText}
      </div>                      
    </div>
  </>
)

ErrorBlock.propTypes = {
  headerText: PropTypes.string.isRequired,
  descriptionText: PropTypes.string.isRequired
}
  
export default ErrorBlock